import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, switchMap } from 'rxjs';
import { FormGroup } from '@angular/forms';
// This is the TypedDocumentNode generated by GraphQL Code Generator
import { graphql } from '../../gql';
import { SharedModule, CustomDetailComponent, DataService } from '@vendure/admin-ui/core';
// import { CmsDataService } from '../../providers/cms-data.service';

const getCustomerPaymentMethodsDocument = graphql(`
  query GetCustomerPaymentMethods($customerId: String!) {
    customerPaymentMethods(fields: { customerId: $customerId }) {
        items {
            id,
            maskNumber,
            type,
            cardBrand,
            createdAt,
            expireAt
        }
        totalItems
    }
  }
`);

@Component({
    selector: 'xxxx',
    templateUrl: './custom.details.components.html',
    standalone: true,
    providers: [],
    imports: [SharedModule],
})
export class CustomerPaymentMethodsComponent implements CustomDetailComponent, OnInit {
    // These two properties are provided by Vendure and will vary
    // depending on the particular detail page you are embedding this
    // component into. In this case, it will be a "product" entity.
    entity$: Observable<any>
    detailForm: FormGroup;
    items$:Observable<any>;
    totalItems$ = 0
    data!: any[]

    extraInfo$: Observable<any>;

    constructor(private dataService: DataService, private router: Router, private route: ActivatedRoute) {
    }


    async ngOnInit() {
        const customerId = this.route.snapshot.parent!.paramMap.get('id')! || '';
        const res = this
            .dataService
            .query(getCustomerPaymentMethodsDocument, { customerId })
            .single$.subscribe((d) => {
                this.data = d.customerPaymentMethods.items;
            });
    }
}